import React, { useEffect, useMemo, useState } from 'react';
import API, { CAPTCHA_ACTIVE, CAPTCHA_KEY, FINGERPRINT_KEY } from '../API';
import { Button, Groupper, Header, Icon } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useRef } from 'react';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import { SetLoading } from '../PublicClasses';
import * as uuid from 'uuid';
import ReCAPTCHA from 'react-google-recaptcha';

const JOIN_TIMER = parseInt(process.env.REACT_APP_JOIN_TIMER) || 2500;
var randomRange = (min: number, max: number)=>Math.floor(Math.random() * (max-min+1)+min);

interface QueueJoinProps{
	rejoin?: boolean,
}

var QueueJoin = (props: QueueJoinProps)=>{
	var navigate = useNavigate();
	var { t } = useTranslation();
	var { data: fpData, getData } = useVisitorData({ ignoreCache: false }, { immediate: false });
	var [loading, setLoading] = useState<boolean>(false);
	var [endedMessage, setEndedMessage] = useState<string>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [searchParams] = useSearchParams();
	var recaptchaRef = useRef<ReCAPTCHA>(null);
	var params = useParams<{ token: string }>();

	var website_id = useMemo(()=>{
		var w = searchParams.get('w');
		if(!w || Number.isNaN(parseInt(w))) return null;
		else return parseInt(w);
	}, [params]);

	if(!params || !params.token || params.token.length<10){
		return <Header style={{ fontSize: 100 }} subheaderStyle={{ fontSize: 16 }} text={404} subtext={t('join.no_token')} />
	}

	var resetJoin = ()=>{
		recaptchaRef.current?.reset();
		setLoading(false);
		setLoadError(null);
	}

	var joinQueue = (captcha: string)=>{
		return (setLoading: SetLoading)=>{
			setLoading(true);
			setTimeout(async ()=>{
				var unique_id : string = null;
				// if(FINGERPRINT_KEY){
					// if(fpData && fpData.visitorId){
					// 	unique_id = fpData.visitorId;
					// }else{
						try{
							var lcl_u = localStorage.getItem('unique-random');
							if(lcl_u) unique_id = lcl_u;
						}catch(e){}

						if(!unique_id){
							try{
								// var fingerprint = await getData({ ignoreCache: false });
								// unique_id = fingerprint.visitorId;
								// unique_id = randomRange(0, 9999999999).toString(20);
								unique_id = uuid.v7();
								localStorage.setItem('unique-random', unique_id);
							}catch(e){
								setLoading(false);
								return setLoadError(t('join.fingerprint_error'));
							}
						}
					// }
				// }
				
				API.joinQueue(website_id, params.token, unique_id, captcha, !!props.rejoin).then(res=>{
					if(res.error) return setLoadError(res.message);
					if(res.data.finish_token){
						return navigate(`/f/${res.data.finish_token}?w=${website_id}`);
					}else if(res.data.wait_token){
						return navigate(`/w/${res.data.wait_token}?w=${website_id}`);
					}else if(res.data.ended){
						return setEndedMessage(res.data.ended_message || t('join.queue_ended'));
					}else{
						return setLoadError(t('common.unexpected_error', { code: 'JNQU-NR-1' }));
					}
				}).catch(err=>{
					return setLoadError(t('common.unexpected_error', { code: 'JNQU-1' }));
				}).finally(()=>{
					setLoading(false);
				})
			}, randomRange(JOIN_TIMER, JOIN_TIMER*2));
		}
	}
	
	return <Groupper className='ca join-screen' title={t('common.queue')} titleCentered>
		<div className="contents">
			{(!!loadError || !!endedMessage) ? <>
				<Icon name={loadError ? 'triangle-exclamation' : 'frown-open'} />
				<div className="title">
					{t(loadError ? 'common.error' : 'join.ended_title')}
				</div>
				<div className="text error">
					{loadError || endedMessage}
				</div>
				{!endedMessage && (
					<Button text='Regresar' onClick={resetJoin} />
				)}
			</> : <>
				<Icon name='users-line' />
				<div className="title">
					{t('common.queue')}
				</div>
				<div className="text">{t('join.description')}</div>
				{CAPTCHA_ACTIVE && CAPTCHA_KEY ? <>
					<div className="text captcha">{t('join.captcha')}</div>
					{loading ? (
						<div className="recaptcha loading">
							<div className="fr inline loading"></div>
							<div className="text">{t('join.joining')}</div>
						</div>
					) : (
						<ReCAPTCHA size='normal' sitekey={CAPTCHA_KEY} ref={recaptchaRef} onChange={(c)=>{
							joinQueue(c)(setLoading);
						}} className='recaptcha' />
					)}
				</> : (
					<Button color='red' text='Entrar' onClick={joinQueue(null)} />
				)}
			</>}
		</div>
	</Groupper>
}

export default QueueJoin;